import React from 'react';

export const AgendaSkeleton: React.FC = () => (
    <div className="divide-y divide-gray-100">
        {Array.from({ length: 5 }).map((_, index) => (
            <div key={index} className="flex items-center gap-3 px-5 py-3.5">
                <div className="w-[86px] h-3.5 bg-gray-200 rounded animate-pulse" />
                <div className="h-8 w-8 rounded-full bg-gray-200 animate-pulse shrink-0" />
                <div className="flex-1 space-y-1.5">
                    <div className="h-3 w-1/3 bg-gray-200 rounded animate-pulse" />
                    <div className="h-2.5 w-1/4 bg-gray-200 rounded animate-pulse" />
                </div>
            </div>
        ))}
    </div>
);

export interface AgendaErrorProps {
    onRetry: () => void;
}

export const AgendaError: React.FC<AgendaErrorProps> = ({ onRetry }) => (
    <div className="h-full grid place-items-center px-8 text-center">
        <div>
            <h3 className="text-[13.5px] font-semibold text-gray-800">
                Couldn&rsquo;t load appointments
            </h3>
            <p className="mx-auto mt-1.5 max-w-xs text-[12.5px] leading-relaxed text-gray-500">
                Something went wrong fetching the agenda. Try again.
            </p>
            <button
                type="button"
                onClick={onRetry}
                className="mt-4 inline-flex items-center gap-2 rounded-lg bg-gray-900 px-4 py-2 text-[13px] font-medium text-white hover:bg-gray-800"
            >
                Retry
            </button>
        </div>
    </div>
);
